import { apolloClient } from '../apolloClient'
import { DELETE_OWN_NOTIFICATION } from './mutations/DELETE_OWN_NOTIFICATION'
import { DeleteOwnNotification, DeleteOwnNotificationVariables } from '../types/DeleteOwnNotification'
import { setGlobal } from '../../global/useGlobal'

export const deleteOwnNotification = async (input: string) => {
  const response = await apolloClient.mutate<DeleteOwnNotification, DeleteOwnNotificationVariables>({
    mutation: DELETE_OWN_NOTIFICATION,
    variables: { input: input },
  })

  if (response) {
    setGlobal({
      deleteOwnNotificationMessage: response.data?.deleteOwnNotificationById?.message,
    })
  }
}
